import hideFocusStylesForMouse from './utils';
import initEntryFilters from './entry-filter';
import initInfiniteScrollSections from './infinite-scroll';
import WallOfGratitude from './wall-of-gratitude'
import PayPalPayFlow from './paypal-payflow'
import Dropdown from './dropdown'
import HamburgerMenu from './thought-leadership/hamburger-menu'
import Industries from './brand-protection/industries'
import Modal from './video-modal'
import PopupDynamic from './popup-dynamic'
import HotJobsFilter from './components/hot-jobs-filter'
import './smooth-scroll';
import './accordions';
import './tabs';
import './utility-nav';
import './contact-form';
import './nav-bar';
import AOS from 'aos';
import simpleParallax from 'simple-parallax-js';

initEntryFilters();
initInfiniteScrollSections();
hideFocusStylesForMouse();

// Thought Leadership Page
new Dropdown();
new HamburgerMenu();

// Brand Leadership
new Industries();

// Payment Form (PayPal PayFlow)
new PayPalPayFlow();

// Used on Season of Giving page only
if ($('.cheer-comments').length > 0) {
    window.WallOfGratitude = new WallOfGratitude();
}

if (window.flexibility) window.flexibility(document.documentElement);

// Rims 2021 Page
if ($('#rims-page').length > 0) {
    var $rimsAccordions = $('.accordions-component .accordion')

    function rimsCloseAllAccordions($accordionComponent) {
        $accordionComponent.find('.accordion').removeClass('open')
    }

    function rimsEvents() {
        $('.accordions-component .accordion').on('click', function() {
            var $accordion = $(this)
            var $accordionComponent = $accordion.parents('.accordions-component')
            var singleOpen = $accordionComponent.hasClass('single')
            var currentlyOpen = $accordion.hasClass('open')

            if (singleOpen) {
                rimsCloseAllAccordions($accordionComponent)

                if (currentlyOpen) {
                    return
                }
            }

            $accordion.toggleClass('open')
        })
    }

    rimsEvents()

    // Video Modal
    new Modal()
}

function hasElement($element) {
    if ($element.length <= 0) {
        return false
    }

    return true
}

// On Season of Giving 2021 Page
if (hasElement($('#season-of-giving-2021'))) {
    function sogPopupInit() {
        var $popupDynamic = new PopupDynamic()

        // Events
        $('.dynamic-popup-btn').on('click', function() {
            let position = $(this).attr('data-position')
            let popupHTML = $(this).parent().next('.popup')[0].outerHTML

            $popupDynamic
                .setHTML(popupHTML)
                .setPosition(position)
                .show();
        })

        $('#dynamic-popup-display-container').on('click', '.dynamic-popup-close-btn', function(e) {
            e.stopPropagation()
            $popupDynamic.removePopup()
        })
    }

    function sogParallax() {
        const mountainImage = document.getElementsByClassName('mountain')

        new simpleParallax(mountainImage, {
            orientation: 'down',
            scale: 1.2,
        })
    }

    sogPopupInit()
    sogParallax()
}

// On Careers Page
if (hasElement($('#careers-landing-page'))) {
    function careersPopupInit() {
        var $popupDynamic = new PopupDynamic()

        $('.dynamic-popup-btn').on('click', function() {
            let popupHTML = $(this).parent().next('.popup')[0].outerHTML

            $popupDynamic
                .setHTML(popupHTML)
                .show();
        })

        $('#dynamic-popup-display-container').on('click', '.dynamic-popup-close-btn', function(e) {
            e.stopPropagation()
            $popupDynamic.removePopup()
        })
    }

    careersPopupInit()

    // Hot Jobs Section
    new HotJobsFilter()
}

// On Season of Giving 2021 and Careers Page
if (
    hasElement($('#season-of-giving-2021')) ||
    hasElement($('#careers-landing-page'))
) {
    AOS.init({
        duration: 800,
        easing: 'ease',
        once: true,
    })
}
